import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Logger from '../../../lib/analytics/logger';
import { EVENT_ACTIONS, EVENT_DOMAINS, EVENT_SCREENS, EVENT_WIDGETS } from '../../../lib/analytics/constants';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import store from '../../../state/store';
import { FEATURES_LIST, PURCHASE_TYPE } from '../../../constants/types';
import { REWARD_CENTER_CATEGORY_ICON_TYPE, REWARD_CENTER_EVENT_TYPES } from '../constants';
import { getOfferPriceValue, isCoinOffer } from '../utils/validations';
var hasValue = function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
};
var normalizeNumericValue = function normalizeNumericValue(value) {
  if (!hasValue(value)) return null;
  var numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};
var normalizeFailureReason = function normalizeFailureReason(failureReason) {
  if (!hasValue(failureReason)) return null;
  return "".concat(failureReason).trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
};
var isRedeemCoinsCategory = function isRedeemCoinsCategory(category) {
  return (category === null || category === void 0 ? void 0 : category.categoryIconType) === REWARD_CENTER_CATEGORY_ICON_TYPE.REDEEM_COINS || (category === null || category === void 0 ? void 0 : category.isUseCoinsCategory);
};
var getPlayerRewardContext = function getPlayerRewardContext() {
  var _store$getState = store.getState(),
    _store$getState$playe = _store$getState.playerInfo,
    _store$getState$playe2 = _store$getState$playe === void 0 ? {} : _store$getState$playe,
    _store$getState$playe3 = _store$getState$playe2.propertyId,
    propertyId = _store$getState$playe3 === void 0 ? null : _store$getState$playe3,
    _store$getState$playe4 = _store$getState$playe2.propertyName,
    propertyName = _store$getState$playe4 === void 0 ? null : _store$getState$playe4,
    _store$getState$coin = _store$getState.coin,
    _store$getState$coin2 = _store$getState$coin === void 0 ? {} : _store$getState$coin,
    _store$getState$coin3 = _store$getState$coin2.value,
    coinBalance = _store$getState$coin3 === void 0 ? null : _store$getState$coin3;
  return {
    propertyId: propertyId,
    propertyName: propertyName,
    coinBalance: normalizeNumericValue(coinBalance)
  };
};
var getOfferRewardType = function getOfferRewardType(offer) {
  var _ref, _offer$rewardType;
  return (_ref = (_offer$rewardType = offer === null || offer === void 0 ? void 0 : offer.rewardType) !== null && _offer$rewardType !== void 0 ? _offer$rewardType : offer === null || offer === void 0 ? void 0 : offer.rewardtype) !== null && _ref !== void 0 ? _ref : null;
};
var getOfferType = function getOfferType(offer) {
  var _ref2, _ref3, _offer$rewardName;
  var rewardType = getOfferRewardType(offer);
  if (rewardType === PURCHASE_TYPE.VIP_ROOM_ACCESS) return 'VIP Pass';
  return (_ref2 = (_ref3 = (_offer$rewardName = offer === null || offer === void 0 ? void 0 : offer.rewardName) !== null && _offer$rewardName !== void 0 ? _offer$rewardName : offer === null || offer === void 0 ? void 0 : offer.rewardname) !== null && _ref3 !== void 0 ? _ref3 : rewardType) !== null && _ref2 !== void 0 ? _ref2 : null;
};
var getVipPassDuration = function getVipPassDuration(offer) {
  var _ref4, _offer$subtitle;
  var rewardType = getOfferRewardType(offer);
  return rewardType === PURCHASE_TYPE.VIP_ROOM_ACCESS ? (_ref4 = (_offer$subtitle = offer === null || offer === void 0 ? void 0 : offer.subtitle) !== null && _offer$subtitle !== void 0 ? _offer$subtitle : offer === null || offer === void 0 ? void 0 : offer.benefitDescription) !== null && _ref4 !== void 0 ? _ref4 : null : null;
};
var removeEmptyPayloadValues = function removeEmptyPayloadValues(payload) {
  return Object.entries(payload).reduce(function (result, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    if (hasValue(value)) {
      result[key] = value;
    }
    return result;
  }, {});
};
var coinRedemptionUiEventConfig = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, REWARD_CENTER_EVENT_TYPES.RC_REDEEM_VIEWED, {
  action: EVENT_ACTIONS.DISPLAY,
  widget: EVENT_WIDGETS[EVENT_DOMAINS.REWARD_CENTER].REWARD_CENTER_CATEGORY
}), REWARD_CENTER_EVENT_TYPES.RC_REDEEM_OFFER_VIEWED, {
  action: EVENT_ACTIONS.DISPLAY,
  widget: EVENT_WIDGETS[EVENT_DOMAINS.REWARD_CENTER].REWARD_CENTER_OFFER
}), REWARD_CENTER_EVENT_TYPES.RC_REDEEM_ATTEMPTED, {
  action: EVENT_ACTIONS.PRESS,
  widget: EVENT_WIDGETS[EVENT_DOMAINS.REWARD_CENTER].REWARD_CENTER_REDEEM_BUTTON
}), REWARD_CENTER_EVENT_TYPES.RC_REDEEM_SUCCESS, {
  action: EVENT_ACTIONS.COMPLETE,
  widget: EVENT_WIDGETS[EVENT_DOMAINS.REWARD_CENTER].REWARD_CENTER_REDEEM_BUTTON
}), REWARD_CENTER_EVENT_TYPES.RC_REDEEM_FAILED, {
  action: EVENT_ACTIONS.FAIL,
  widget: EVENT_WIDGETS[EVENT_DOMAINS.REWARD_CENTER].REWARD_CENTER_REDEEM_BUTTON
});
var buildRewardCenterRedeemPayload = function buildRewardCenterRedeemPayload() {
  var _ref8, _category$categoryId, _ref9, _offer$offerId;
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$offer = _ref7.offer,
    offer = _ref7$offer === void 0 ? null : _ref7$offer,
    _ref7$category = _ref7.category,
    category = _ref7$category === void 0 ? null : _ref7$category,
    _ref7$propertyId = _ref7.propertyId,
    propertyId = _ref7$propertyId === void 0 ? null : _ref7$propertyId,
    _ref7$propertyName = _ref7.propertyName,
    propertyName = _ref7$propertyName === void 0 ? null : _ref7$propertyName,
    _ref7$playerCoinBalan = _ref7.playerCoinBalanceBefore,
    playerCoinBalanceBefore = _ref7$playerCoinBalan === void 0 ? null : _ref7$playerCoinBalan,
    _ref7$playerCoinBalan2 = _ref7.playerCoinBalanceAfter,
    playerCoinBalanceAfter = _ref7$playerCoinBalan2 === void 0 ? null : _ref7$playerCoinBalan2,
    _ref7$attemptStatus = _ref7.attemptStatus,
    attemptStatus = _ref7$attemptStatus === void 0 ? null : _ref7$attemptStatus,
    _ref7$resultStatus = _ref7.resultStatus,
    resultStatus = _ref7$resultStatus === void 0 ? null : _ref7$resultStatus,
    _ref7$failureReason = _ref7.failureReason,
    failureReason = _ref7$failureReason === void 0 ? null : _ref7$failureReason;
  var playerRewardContext = getPlayerRewardContext();
  var resolvedPropertyId = propertyId !== null && propertyId !== void 0 ? propertyId : playerRewardContext.propertyId;
  var resolvedPropertyName = propertyName !== null && propertyName !== void 0 ? propertyName : playerRewardContext.propertyName;
  var resolvedCategoryId = (_ref8 = (_category$categoryId = category === null || category === void 0 ? void 0 : category.categoryId) !== null && _category$categoryId !== void 0 ? _category$categoryId : offer === null || offer === void 0 ? void 0 : offer.categoryId) !== null && _ref8 !== void 0 ? _ref8 : null;
  var resolvedOfferId = (_ref9 = (_offer$offerId = offer === null || offer === void 0 ? void 0 : offer.offerId) !== null && _offer$offerId !== void 0 ? _offer$offerId : offer === null || offer === void 0 ? void 0 : offer.r_id) !== null && _ref9 !== void 0 ? _ref9 : null;
  var coinsRequired = offer ? normalizeNumericValue(getOfferPriceValue(offer)) : null;
  var resolvedCoinBalanceBefore = hasValue(playerCoinBalanceBefore) ? normalizeNumericValue(playerCoinBalanceBefore) : playerRewardContext.coinBalance;
  var resolvedCoinBalanceAfter = hasValue(playerCoinBalanceAfter) ? normalizeNumericValue(playerCoinBalanceAfter) : resolvedCoinBalanceBefore;
  return removeEmptyPayloadValues({
    rc_id: resolvedCategoryId,
    r_id: resolvedOfferId,
    prop_id: resolvedPropertyId,
    context_reward_center_property_name: resolvedPropertyName,
    context_reward_center_offer_type: offer ? getOfferType(offer) : null,
    context_reward_center_reward_type: offer ? getOfferRewardType(offer) : null,
    context_reward_center_coins_required: coinsRequired,
    context_reward_center_coin_balance_before: resolvedCoinBalanceBefore,
    context_reward_center_coin_balance_after: resolvedCoinBalanceAfter,
    context_reward_center_vip_pass_duration: offer ? getVipPassDuration(offer) : null,
    context_reward_center_attempt_status: attemptStatus,
    context_reward_center_result_status: resultStatus,
    context_reward_center_failure_reason: normalizeFailureReason(failureReason)
  });
};
var sendCoinRedemptionEvent = function sendCoinRedemptionEvent(eventType) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var uiEventConfig = coinRedemptionUiEventConfig[eventType];
  if (!uiEventConfig) return;
  var rewardCenterRedeemPayload = buildRewardCenterRedeemPayload(payload);
  Logger.sendEvent(EVENT_TYPES.UI_EVENT, _objectSpread(_objectSpread({}, uiEventConfig), {}, {
    domain: EVENT_DOMAINS.REWARD_CENTER,
    screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].MAIN,
    context_reward_center_event: eventType
  }, rewardCenterRedeemPayload));
};
export var sendRewardCenterEvent = function sendRewardCenterEvent(eventType) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (eventType) {
    case REWARD_CENTER_EVENT_TYPES.ENTER_REWARD_CENTER_SCREEN:
      Logger.sendEvent(EVENT_TYPES.UI_EVENT, {
        action: EVENT_ACTIONS.DISPLAY,
        domain: EVENT_DOMAINS.REWARD_CENTER,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].MAIN
      });
      Logger.sendEvent(EVENT_TYPES.GTM_FEATURE_ENGAGEMENT, {
        feature: FEATURES_LIST.REWARD_CENTER
      });
      break;
    case REWARD_CENTER_EVENT_TYPES.OPEN_REWARD_CENTER_CATEGORY:
      {
        var _payload$category$cat, _payload$category;
        var categoryId = (_payload$category$cat = (_payload$category = payload.category) === null || _payload$category === void 0 ? void 0 : _payload$category.categoryId) !== null && _payload$category$cat !== void 0 ? _payload$category$cat : payload.categoryId;
        Logger.sendEvent(EVENT_TYPES.UI_EVENT, {
          action: EVENT_ACTIONS.PRESS,
          domain: EVENT_DOMAINS.REWARD_CENTER,
          screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].MAIN,
          widget: EVENT_WIDGETS[EVENT_DOMAINS.REWARD_CENTER].REWARD_CENTER_CATEGORY,
          rc_id: categoryId
        });
        if (isRedeemCoinsCategory(payload.category)) {
          sendCoinRedemptionEvent(REWARD_CENTER_EVENT_TYPES.RC_REDEEM_VIEWED, payload);
        }
        break;
      }
    case REWARD_CENTER_EVENT_TYPES.OPEN_REWARD_CENTER_OFFER:
      {
        var _payload$offer$offerI, _payload$offer;
        var offerId = (_payload$offer$offerI = (_payload$offer = payload.offer) === null || _payload$offer === void 0 ? void 0 : _payload$offer.offerId) !== null && _payload$offer$offerI !== void 0 ? _payload$offer$offerI : payload.offerId;
        Logger.sendEvent(EVENT_TYPES.UI_EVENT, {
          action: EVENT_ACTIONS.PRESS,
          domain: EVENT_DOMAINS.REWARD_CENTER,
          screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].MAIN,
          widget: EVENT_WIDGETS[EVENT_DOMAINS.REWARD_CENTER].REWARD_CENTER_OFFER,
          r_id: offerId
        });
        break;
      }
    case REWARD_CENTER_EVENT_TYPES.RC_REDEEM_VIEWED:
      sendCoinRedemptionEvent(REWARD_CENTER_EVENT_TYPES.RC_REDEEM_VIEWED, payload);
      break;
    case REWARD_CENTER_EVENT_TYPES.RC_REDEEM_OFFER_VIEWED:
      if (isCoinOffer(payload.offer)) {
        sendCoinRedemptionEvent(REWARD_CENTER_EVENT_TYPES.RC_REDEEM_OFFER_VIEWED, payload);
      }
      break;
    case REWARD_CENTER_EVENT_TYPES.RC_REDEEM_ATTEMPTED:
      if (isCoinOffer(payload.offer)) {
        sendCoinRedemptionEvent(REWARD_CENTER_EVENT_TYPES.RC_REDEEM_ATTEMPTED, payload);
      }
      break;
    case REWARD_CENTER_EVENT_TYPES.RC_REDEEM_SUCCESS:
      if (isCoinOffer(payload.offer)) {
        sendCoinRedemptionEvent(REWARD_CENTER_EVENT_TYPES.RC_REDEEM_SUCCESS, payload);
      }
      break;
    case REWARD_CENTER_EVENT_TYPES.RC_REDEEM_FAILED:
      if (isCoinOffer(payload.offer)) {
        sendCoinRedemptionEvent(REWARD_CENTER_EVENT_TYPES.RC_REDEEM_FAILED, payload);
      }
      break;
    default:
      break;
  }
};